// Top-bar "time on this contact" chip -- how long the current agent has held
// the active tab's claim, ticking live. Purely a display: assignedAt (epoch
// ms) is reported by App.jsx's Shell from the same conversation_assignments
// claim every AHT report already reads server-side (see
// repositories/assignments.js's claimOrRefresh/rowToOwnerView) -- no new
// backend concept, this just surfaces an existing timestamp.
//
// Raw wall-clock elapsed EXCEPT parked time (2026-10-08). parkedMs is the
// total of the closed parks on this same claim (the heartbeat's owner view),
// so resuming a parked contact carries on from where it was before Park: the
// contact was set aside on purpose, and reporting's handle time leaves parked
// time out too. A Take Over or Return to Queue is a new claim, so its chip
// starts from 0. A confirmed inactivity pause is still NOT subtracted the way
// reporting's AHT subtracts it -- an agent glancing at this wants "how long
// have I been sitting on this," not a reporting-grade net figure. Worth a
// conscious call, not an oversight, if this gets revisited.
import { useEffect, useState } from 'react'
import { Chip } from '@mui/material'
import { elapsedOnContact, formatElapsed } from './contactTimer.js'

export default function ActiveContactTimer({ assignedAt, parkedMs = 0, sx }) {
  const [, forceTick] = useState(0)

  useEffect(() => {
    if (assignedAt == null) return
    const id = setInterval(() => forceTick((n) => n + 1), 1000)
    return () => clearInterval(id)
  }, [assignedAt])

  if (assignedAt == null) return null

  return (
    <Chip
      size="small"
      variant="outlined"
      label={formatElapsed(elapsedOnContact(Date.now(), assignedAt, parkedMs))}
      sx={{ fontFamily: 'monospace', ...sx }}
      aria-label="Time on this contact"
    />
  )
}
